import { Share, UnfoldLess } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';

import { Button } from '@/components';
import { Modals } from '@/constants';
import { AnalyticsService, EVENT_CONSTANTS } from '@/services';
import {
  playerActions,
  selectActiveEpisodeId,
  selectEpisodeCompliance,
  selectSessionUserId,
  uiActions,
  useAppSelector,
  useFetchEpisodeQuery,
} from '@/store';
import { SnackbarUtils } from '@/utils';

export const TopControls = () => {
  const dispatch = useDispatch();

  const userId = useAppSelector(selectSessionUserId);
  const activeEpisodeId = useAppSelector(selectActiveEpisodeId);
  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, activeEpisodeId),
  );
  const { data: episode } = useFetchEpisodeQuery({
    episodeId: activeEpisodeId!,
    compliance,
  });

  const location = { component: EVENT_CONSTANTS.COMPONENT.VIDEO_PLAYER };

  const onMinimize = () => {
    dispatch(playerActions.setExpanded(false));
  };

  return (
    <Box sx={styles.buttonContainer}>
      {episode && (
        <Button
          variant="tertiary"
          label="Share"
          onClick={() => {
            if (userId) {
              dispatch(
                uiActions.setActiveModal({
                  name: Modals.SHARE_EPISODE,
                  params: { episodeId: activeEpisodeId, referrer: location },
                }),
              );
            } else {
              navigator.clipboard.writeText(episode?.deepLink);
              AnalyticsService.episodeShareCopy({
                episodeId: activeEpisodeId!,
                location: { ...location, button: EVENT_CONSTANTS.BUTTON.SHARE },
              });
              SnackbarUtils.success('Link copied to clipboard');
            }
          }}
          startIcon={<Share />}
          colorOverride="white"
          fullWidth={false}
        />
      )}
      <Button
        variant="tertiary"
        label="Minimize"
        onClick={onMinimize}
        startIcon={<UnfoldLess />}
        colorOverride="white"
        fullWidth={false}
      />
    </Box>
  );
};

const styles = {
  buttonContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    mb: 2,
  },
};
